import { useCallback, useMemo } from 'react';
import parsePhoneNumberFromString, { AsYouType, CountryCode } from 'libphonenumber-js/mobile';
import { useQueryGetProjectOptional } from '../../core/queries/projects.queries';

export const useMobilePhoneFormatter = (projectID?: string) => {
  const countryCode = ((useQueryGetProjectOptional(projectID)?.data as { countryCode?: string } | undefined)
    ?.countryCode ?? 'AU') as CountryCode;

  const asYouType = useMemo(() => new AsYouType(countryCode), [countryCode]);

  return useCallback(
    (dirtyMobile: string) => {
      asYouType.reset();
      // Hack to drop zero when someone starts typing an 04-number in Australia
      const withFirstZeroReplaced =
        countryCode === 'AU'
          ? dirtyMobile.replace(/^([^0-9]*)0/, '$1+61')
          : countryCode === 'NZ'
          ? dirtyMobile.replace(/^([^0-9]*)0/, '$1+64')
          : dirtyMobile;
      const international = parsePhoneNumberFromString(withFirstZeroReplaced, countryCode)?.number ?? dirtyMobile;
      return asYouType.input(international);
    },
    [asYouType, countryCode]
  );
};
